import {GroupedOption, Option} from 'platform/components';

import {isEmpty, isNil} from 'ramda';

import {GetManufacturersResponse} from '@dms/api/core';
import {CatalogNumberSuggestion} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {getOptionsFromManufacturers} from '@dms/shared';

import {Nullish} from 'shared/web';

export const getOptionsFromManufacturersWithSuggestions = (
  catalogNumber: string | Nullish,
  manufacturers: GetManufacturersResponse | Nullish,
  suggestions: CatalogNumberSuggestion[] | Nullish
): Option[] | GroupedOption[] => {
  if (isNil(manufacturers)) {
    return [];
  }

  const suggestedArticles =
    suggestions?.find(
      (suggestion) => suggestion.catalogueNumber === catalogNumber?.replace(/\s+/g, '')
    )?.articles ?? [];

  if (isNil(catalogNumber) || isEmpty(suggestedArticles)) {
    return getOptionsFromManufacturers(manufacturers);
  }

  const suggestedOptions = suggestedArticles
    .filter((suggestion) => suggestion.manufacturer.name && suggestion.manufacturer.manufacturerId)
    .map((suggestion) => ({
      label: suggestion.manufacturer.name,
      value: suggestion.manufacturer.manufacturerId,
    }));

  const allManufacturerOptions = getOptionsFromManufacturers(manufacturers);

  return [
    {
      label: i18n.t('entity.documentExtraction.labels.suggestedManufacturers'),
      options: suggestedOptions,
    },
    {
      label: i18n.t('entity.documentExtraction.labels.allManufacturers'),
      options: allManufacturerOptions,
    },
  ];
};
